module.exports = __webpack_public_path__ + "static/media/order1.79587bda.png";